import HeaderBlock from '../../components/HeaderBlock.vue'
import FooterBlock from '../../components/FooterBlock.vue'
import SideBar from '../../components/SideBar.vue'
import { mapActions } from 'vuex'
import { throttle } from 'lodash'
import api from '@/api'

export default {
  name: 'HomeIndex',
  components: {
    HeaderBlock,
    FooterBlock,
    SideBar
  },
  async created () {
    await this.getUserInfo()
  },
  computed: {
    sidebarHidden () {
      return this.$store.state.appSettings.sidebarHidden
    },
    isShowContent () {
      return !!this.$store.state.userInfo
    }
  },
  methods: {
    checkUser () {
      api.get.profile()
    },
    onClick: throttle(function () { this.checkUser() }, 10 * 60 * 1000),
    ...mapActions({
      getUserInfo: 'GET_USER_INFO'
    })
  }
}
